import {
  startOfMonth, endOfMonth, startOfYear, endOfYear, subDays, subMonths, subYears, format,
} from 'date-fns';

export const formatDate = (date, dateFormat = 'dd. MM. yyyy') => {
  if (!date) return '';
  return format(date, dateFormat);
};

export const formatedDateRange = (
  period,
  { dateFns = 'dd. MM. yyyy', rangeSeparator = ' - ' } = {},
) => {
  try {
    const today = new Date();
    let from = null;
    let to = null;
    let tempDate;

    switch (period) {
      case 'today':
        from = today;
        break;
      case 'yesterday':
        from = subDays(today, 1);
        break;
      case 'this_month':
        from = startOfMonth(today);
        to = endOfMonth(today);
        break;
      case 'last_month':
        tempDate = subMonths(today, 1);
        from = startOfMonth(tempDate);
        to = endOfMonth(tempDate);
        break;
      case 'this_year':
        from = startOfYear(today);
        to = endOfYear(today);
        break;
      case 'last_year':
        tempDate = subYears(today, 1);
        from = startOfYear(tempDate);
        to = endOfYear(tempDate);
        break;
      case 'last_12_months':
        from = subYears(today, 1);
        to = today;
        break;
      case 'q1':
        from = startOfYear(today);
        to = new Date(today.getFullYear(), 2, 31);
        break;
      case 'q2':
        from = new Date(today.getFullYear(), 3, 1);
        to = new Date(today.getFullYear(), 5, 30);
        break;
      case 'q3':
        from = new Date(today.getFullYear(), 6, 1);
        to = new Date(today.getFullYear(), 8, 30);
        break;
      case 'q4':
        from = new Date(today.getFullYear(), 9, 1);
        to = new Date(today.getFullYear(), 11, 31);
        break;
      case 'custom':
        from = today;
        to = today;
        break;
      default:
        from = null;
        to = null;

        break;
    }

    if (!from && !to) {
      return '';
    }

    return `(${formatDate(from, dateFns)}${to ? rangeSeparator : ''}${to ? formatDate(to, dateFns) : ''})`;
  } catch (error) {
    return null;
  }
};
